import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbNav, NgbNavConfig } from '@ng-bootstrap/ng-bootstrap';
import { ColumnChooserService, PageService, SelectionSettingsModel, ToolbarService, VirtualScrollService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations/src';
import { DialogComponent, TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { IProgressValueEventArgs } from '@syncfusion/ej2-angular-progressbar';
import { EmitType } from '@syncfusion/ej2-base';
import { Column, ColumnChooser, DataStateChangeEventArgs, FilterSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { TextBox } from '@syncfusion/ej2-inputs';
import { Tooltip } from '@syncfusion/ej2-popups';
import { AnimationModel, ILoadedEventArgs, ProgressBar } from '@syncfusion/ej2-progressbar';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription, timer } from 'rxjs';
import { AttributeStatusEnum, DataScopesEnum, ExportStatusEnum, MessageSeverityEnum, RegistrationTypeEnum, ValidationStatusEnum } from '../../shared/enums/index';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { fadeInOut } from '../../shared/helpers/animations';
import { ICustomer, ILanguageApiResponse, IServiceError, ISubmission, ISubmissionItem, IUserPrefs, IValidation, IValidationItem } from '../../shared/models/index';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { AuthorizationService } from '../../shared/services/authorization.service';
import { CustomerService, DeviceinventoryService, ExportDataService, SettingsService, StorageManagerService } from '../../shared/services/index';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { AnimationSettingsModel, SpinSettingsModel } from '@syncfusion/ej2-angular-splitbuttons';
import { FeatureService } from '../../shared/services/feature.service';

@Component({
  selector: 'app-deviceinventory',
  templateUrl: './deviceinventory.component.html',
  styleUrls: ['./deviceinventory.component.scss'],
  providers: [ToolbarService, ColumnChooserService, PageService, NgbNavConfig, VirtualScrollService],
  animations: [fadeInOut],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false
})

export class DeviceinventoryComponent extends BaseGridComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {

  toolbar: ToolbarItems[] | object;
  data$: Observable<DataStateChangeEventArgs>;
  pageOptions: Object;
  state: DataStateChangeEventArgs;
  filterSettings: FilterSettingsModel;
  hide = false;
  itemType = 'device';
  customer: ICustomer;
  userGuid: string;
  gridColumns: any[];
  columnChooser: ColumnChooser;
  dataScopeId: number;
  language = 'English';
  dataScope: string;
  dataSourceApi: any;
  dataSource: any[] = [];
  appDefaults: IUserPrefs;
  initial = true;
  initialTabChanged = true;
  tabSwitched = false;
  requiredColumns: string[] = [];
  defaultColumns: string[] = [];
  userColumns: any[] = [];
  defaultRequiredColumns: any[] = [];
  gridType = 'deviceGrid';
  subscription: Subscription;
  resolverData: any[] | IServiceError;
  userPrefs: IUserPrefs;
  savedUserPrefs: IUserPrefs;
  prefsPerGrid: any;
  retrieveComplete = false;
  initialload = false;
  position: any[] = [];
  defaultPrefsPerGrid: any;
  refreshCount = 0;
  selectionOptions: SelectionSettingsModel;
  selectedRecords: any[] = [];
  currentEvent: string;
  gridComplete = false;
  retrieveInDataState = true;
  submissionBatch: ISubmission[];
  permitted = false;
  MessageSeverityEnum = MessageSeverityEnum;
  ExportStatusEnum = ExportStatusEnum;
  activeTab: string;
  dataScopeEnum = DataScopesEnum;
  validationStatusEnum = ValidationStatusEnum;
  attributeStatusEnum = AttributeStatusEnum;
  appVarId: number;
  downloading = false;
  // selectedEntireItems: any = [];
  selectedItems: any = [];

  target = '#modalTarget';
  modalPosition: object = { X: 'center', Y: 'center' };
  modalWidth = '35%';
  modalHeight = 'auto';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;
  modalVisible = false;
  responseResultArray: any[];
  lastCallTimes: LastCallTime[] = [];
  selectOptions: Object;
  revalidating = false;
  clientLanguageEnabled = false;
  pageLoaded = false;
  downloadInProgress = false;
  timerRevalidationInterval: number;

  // Progress bar
  pbType: string = 'Circular';
  pbWidth: string = '150px';
  pbHeight: string = '150px';
  trackThickness: number = 10;
  progressThickness: number = 10;
  segmentCount: number = 50;
  gapWidth: number = 5;
  circularMin: number = 0;
  circularMax: number;
  circularVal: number = 0;
  startAngle: number = 220;
  endAngle: number = 140;
  progresstimer: any;
  showProgressValue = false;
  animation: AnimationModel = { enable: true, duration: 2000, delay: 0 };

  // Progress Bar button
  spinSettings: SpinSettingsModel = { position: 'Right', width: 20, template: '<div class="template"></div>' };
  buttonAnimationSettings: AnimationSettingsModel = { effect: 'SlideLeft', duration: 500, easing: 'linear' };

  @ViewChild('circular')
  circular: ProgressBar;
  //

  @ViewChild('tabset', { static: true })
  public tabset: NgbNav;

  @ViewChild('submittemplate', { static: true })
  public toolbarSubmitTemplate: any;

  @ViewChild('downloadLogTemplate', { static: true })
  public toolbarDownloadLogTemplate: any;

  @ViewChild('setHaStateTemplate', { static: true })
  public setHaStateTemplate: any;

  @ViewChild('dialog', { static: true })
  public dialog: DialogComponent;
  userPrefObject: any;

  @ViewChild('tooltipObj') tooltipObj: TooltipComponent;

  tooltipContent: HTMLElement = document.createElement('div');

  tooltip = new Tooltip({
    content: this.tooltipContent,
    width: '180px',
    cssClass: 'customtooltip',
    enableHtmlParse: false
  });
  createActionCompleted = true;
  revalidationTimerSubscription: Subscription;
  downloadTimerSubscription: Subscription;
  validationSelectAllSubscription: Subscription;
  featureServiceSubscription: Subscription;
  processedCounter: number;
  progressBarDisplayed = false;
  showLegacyDeviceGrid: boolean = false;
  showLegacyModelGrid: boolean = false;
  currentRegistrationTypeSelection: RegistrationTypeEnum = RegistrationTypeEnum.Regulation;
  dataScopeSwissdamed = false;
  canUpdateRecord = false;
  setHaStateToolbarId = 'sethastate';
  discardHaStateDialogVisible = false;
  haStateChangeInProgress = false;
  haStateReason = '';
  haStateRequestedBy = '';
  haStateServiceTicket = '';
  haStateValidationMessage = '';
  haStateSelectedRecord: any;
  haStateLinkedDeviceCount: number;
  haStateCascadeModel = false;
  haStateTargetStateCode = 19;
  haStateTargetState = 'Discarded';
  haStateTargetAction = 'discard';

  constructor(public service: DeviceinventoryService,
    public storage: StorageManagerService, public router: Router, public activatedRoute: ActivatedRoute,
    public toastr: ToastrService, public cdref: ChangeDetectorRef, public authorizationService: AuthorizationService,
    public authenticationService: AuthenticationService, public appGlobals: AppGlobals,
    public exportDataService: ExportDataService, public settingsService: SettingsService,
    public customerService: CustomerService, public featureService: FeatureService) {

    super(service, storage, router, activatedRoute, toastr, cdref, authorizationService, authenticationService,
      appGlobals, exportDataService, settingsService, customerService, featureService);
  }

  failure(e: any) {
    // debugger;
  }

  ngAfterViewInit(): void {

    if (this.grid && this.grid.columns && this.grid.columns.length > 0) {

      this.applyDefaultPrefs();

      this.buildColumnsPositionArray();

      this.reorderColumns();

      this.pageLoaded = true;
    }
  }

  ngAfterContentChecked(): void {

    this.cdref.detectChanges();
  }

  revalidationCheckTimer(dataScope, registrationTypeSelection) {
    if (this.revalidationTimerSubscription) {
      this.revalidationTimerSubscription.unsubscribe();
    }
    this.revalidationTimerSubscription = timer(3000, this.timerRevalidationInterval).subscribe(() =>
      this.revalidationCheck(this.dataScope, this.currentRegistrationTypeSelection)
    );
  }
  revalidationCheck(dataScope, registrationTypeSelection) {
    // Make the service call only if the Client is enabled for the language support.
    if (this.clientLanguageEnabled && this.dataScope) {
      this.subscription = this.customerService.getMigrationStatusWithRegistration(dataScope, registrationTypeSelection).subscribe((response: ILanguageApiResponse) => {

        if (response.data) {
          this.revalidating = response.data.isMigrating
          this.circularMax = response.data.totalCount;
          this.circularVal = response.data.completedCount;

          // a hack to catch when this.revalidating is changed because the progressComplete falls beteeen the interval calls. If the this.progressBarDisplayed is true, it means that revalidation has started. Since we can't catch the end we are looking for the call when isMigrating becomes false, because this.progressBarDisplayed could be set to true only when revalidation had started.
          if (this.revalidating) {
            this.timerRevalidationInterval = this.serverSettings.hasOwnProperty('APIPollTimeIntervalInMillSeconds') ? this.serverSettings.APIPollTimeIntervalInMillSeconds : 5000;
            this.revalidationCheckTimer(dataScope, registrationTypeSelection);
          } else if (this.progressBarDisplayed && !this.revalidating) {
            this.progressBarDisplayed = false;
            this.grid.refresh();
            this.toastr.success('The updated changes made to the display language have been completed.');
            this.timerRevalidationInterval = this.serverSettings.hasOwnProperty('LanguageRevalidationInterval') ? this.serverSettings.LanguageRevalidationInterval : 20000;
            this.revalidationCheckTimer(dataScope, registrationTypeSelection);
          }
        }
      })
    }
  }

  valueChanged(event) {

    this.processedCounter = event.value;
  }

  // Progress Bar
  loadProgressBar(args: ILoadedEventArgs): void {

    this.progressBarDisplayed = true;

    args.progressBar.annotations[0].content =
      `<div id="point1" class="pb-center-text px-auto pb-4">
      <span class="pb-center-percent"></span>
     <i class="fal fa-exclamation-circle fa fa-3x"></i>
    </div>`;
  }


  progressCompleted(args: IProgressValueEventArgs): void {

    setTimeout(() => {
      this.toastr.success('The updated changes made to the display language have been completed.');
    }, 2500);
  }
  // Progress bar end


  public ngOnInit(): void {

    this.gridComplete = false;
    this.revalidating = false;
    this.permissionsConst = this.appGlobals.permissions;

    this.timerInterval = this.serverSettings.hasOwnProperty('APIPollTimeIntervalInMillSeconds') ? this.serverSettings.APIPollTimeIntervalInMillSeconds : 5000;
    this.timerRevalidationInterval = this.serverSettings.hasOwnProperty('LanguageRevalidationInterval') ? this.serverSettings.LanguageRevalidationInterval : 20000;;

    const customer = this.storage.read('currentCustomer');
    if (customer) {
      this.customer = typeof customer === 'object' ? customer : JSON.parse(customer);
    } else {
      this.router.navigate(['/home']);
    }

    // initiate DataScope values. Needs to be lower case for the Http call
    this.dataScope = this.storage.read('dataScope') ? this.storage.read('dataScope').toLowerCase() : '';
    this.dataScopeEudamed = this.dataScope.toLowerCase() === this.dataScopeEnum.EUDAMED.toLowerCase();
    this.dataScopeSwissdamed = this.dataScope.toLowerCase() === this.dataScopeEnum.SWISSDAMED.toLowerCase();

    if (!this.dataScopeEudamed && !this.dataScopeSwissdamed) {
      this.activeTab = 'device';
      this.storage.write('activeTab', this.activeTab);
    }

    this.activeTab = this.storage.read('activeTab');

    if (this.activeTab) {

      this.tabset.activeId = this.activeTab;
    } else {

      this.tabset.activeId = 'device';
    }

    this.itemType = this.tabset.activeId;
    this.gridType = this.itemType + 'Grid';

    this.selectedItems = [];
    this.storage.write('selectedItems', this.selectedItems);

    // this.selectedEntireItems = [];
    // this.storage.write('selectedEntireItems', this.selectedEntireItems);

    this.selectionOptions = { cellSelectionMode: 'Flow', type: 'Multiple', mode: 'Row', checkboxMode: 'Default', checkboxOnly: true };

    this.userGuid = this.storage.read('userGuid');

    if (this.customer) {
      if (!this.dataScope) {
        this.dataScope = this.customer.applicationVariants[0].applicationVariantName.toLowerCase();
      }

      this.appVarId = this.customer.applicationVariants.find(ap => ap.applicationVariantName.toLowerCase() === this.dataScope.toLowerCase()).applicationVariantId;


      if (!this.userGuid) {
        this.router.navigate(['error', 'User is not logged in']);
      }

      this.filterSettings =
      {
        type: 'Menu',
        operators: {
          stringOperator: [
            { value: 'contains', text: 'contains' },
            { value: 'startsWith', text: 'starts with' },
            { value: 'endsWith', text: 'ends with' },
            { value: 'equal', text: 'equal' }
          ],
          dateOperator: [
            { value: 'contains', text: 'equal' }
          ],
        }
      };

      this.selectOptions = { persistSelection: true };

      this.downloadInProgress = this.service.manageDiDownloadLogBS.getValue();

      // get aggregate data prepared by the resolver
      this.resolverData = this.activatedRoute.snapshot.data['inventoryData'];

      // Get the default prefs.
      // If the user's prefs exist - they are used instead of the app default.
      this.getDefaultSettings();

      this.preExecute(this.state, this.itemType);

      this.data$ = this.service.getData(this.state, this.grid, this.customer.customerId, this.itemType, this.dataScope, this.language);

      this.subscription = this.data$.subscribe((response) => {
        this.data = response;
        // this.data = this.resolverData[3]; // mock

        this.setDeviceCounter();

        this.refreshCount++;

        if (this.grid && this.grid.columns && this.grid.columns.length > 0) {
          this.storeUserPrefs();
        }

        var func = () => {

          if (this.createActionCompleted) {

            if (this.data?.result && this.data?.result.length) {

              const nullStatuses = Array.from(this.data?.result)?.filter(x => !x['Validation Status']);

              if (nullStatuses && nullStatuses.length) {
                const ids = [];

                nullStatuses.forEach(element => {
                  ids.push({
                    documentId: element['id'],
                    dataScope: this.dataScope,
                    itemType: this.itemType
                  })
                });

                this.service.getValidationStatusMultiple(ids).subscribe(response => {

                  if (response && response.data && response.data.length) {
                    // get statuses
                    const updatedStatuses = Array.from(response.data)?.filter(x => x['status']);

                    if (updatedStatuses && updatedStatuses.length) {

                      updatedStatuses.forEach(element => {
                        const foundObject = Array.from(this.data.result).find(x => x['id'] === element['documentId']);

                        if (foundObject) {
                          foundObject['Validation Status'] = element['status'];
                        }
                      });

                      this.grid?.refresh();
                    }

                    setTimeout(() => {
                      func();
                    }, 5000);
                  }
                });
              } else {
                setTimeout(() => {

                  func();
                }, 5000);
              }
            }


          } else {
            setTimeout(() => {

              func();
            }, 5000);
          }
        }

        if (location.pathname.includes('/inventory')) {
          func();
        }

      });
    }

    this.subscription = this.customerService.applicationSettings.subscribe(setting => {
      this.clientLanguageEnabled = !!setting;
      // call the Timer to check if the re-validation is in progress
      if (this.clientLanguageEnabled && this.dataScope) {
        this.revalidationCheckTimer(this.dataScope, this.currentRegistrationTypeSelection);
      }
    });

    // Check to see if EU all the feature turned on for Legacy
    this.featureServiceSubscription = this.featureService.IsFeatureEnabled('eu-legacy-data-import').subscribe(response => {
      if (response) {
        this.isLegacyImportFeatureEnabled = response;
      }
    });


    this.registrationTypeSelection.subscribe((regTypeSelection: RegistrationTypeEnum) => {
      // Handle the Registration Type selection event
      this.currentRegistrationTypeSelection = regTypeSelection;
      this.determineRegistrationType(regTypeSelection);

      // Begin setup to refresh the grid's context needed for filtering
      this.state = {};
      this.data = null;
      this.validatedAll = false;
      this.initialLoad = true; // Needed to kick off the columnChooserOpened event so that we may configure the column selector options.
      this.selectedItems = [];
      this.storage.write('selectedItems', this.selectedItems);
      this.initial = true;
      this.selectAllChecked = false;

      this.deviceCount = -1;
      this.refreshCount = 1; // need to increase to maintain gridComplete.
      this.gridComplete = false;

      this.preExecute(this.state, this.itemType);
      // End setup for grid's context

      // Get the updated datasource
      this.data$ = this.service.getData(this.state, this.grid, this.customer.customerId, this.itemType, this.dataScope, this.language, this.currentRegistrationTypeSelection);

      this.subscription = this.data$.subscribe(response => {
        this.retrieveInDataState = true;
        this.data = response;

        // Set the gridType which used by many processes...
        if (regTypeSelection === RegistrationTypeEnum.Legacy) {
          this.gridType = `${this.itemType}LegacyGrid`;
        }
        else {
          this.gridType = `${this.itemType}Grid`;
        }

        // initialLoad = true is needed to kick off the columnChooserOpened event so that we may configure the column selector options.
        this.initialLoad = true;

        this.setDeviceCounter();

        this.applyDefaultPrefs();

        this.buildColumnsPositionArray();

        this.reorderColumns();
      })
    });
    // set focus on the invisible div so the first tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  toolbarClick(args: ClickEventArgs): void {

    this.action = args.item.id;

    switch (args.item.id) {
      case 'approveselected':
        this.approveSelected();
        break;

      case 'validateselected':
        this.validateSelected();
        break;

      case 'downloadlog':
        this.downloadLog();
        break;

      case this.setHaStateToolbarId:
        if (this.canSetSelectedHaState()) {
          this.openSetHaStateDialog();
        }
        break;
    }
  }

  determineRegistrationType(value: RegistrationTypeEnum): void {
    switch (value) {
      case RegistrationTypeEnum.Legacy:
        this.showLegacyDeviceGrid = true;
        this.showLegacyModelGrid = true;
        break;
      default:
        this.showLegacyDeviceGrid = false;
        this.showLegacyModelGrid = false;
        break;
    }
  }

  validateSelected() {

    if (this.selectAllChecked) {

      this.validatedAll = false;

      let filter = this.getFilterCriteria();

      let registrationType = (this.dataScopeEudamed || this.dataScopeSwissdamed) && this.currentRegistrationTypeSelection === RegistrationTypeEnum.Legacy
        ? RegistrationTypeEnum.Legacy
        : RegistrationTypeEnum.Regulation;

      this.service.validateSelectedAll(this.itemType, this.dataScope, filter, registrationType).subscribe(data => {

        this.validatedAll = data['isSuccess'];
        if (this.validatedAll) {
          this.toastr.success('Your request has been submitted', '', { closeButton: true });
        }

        this.validationSelectAllSubscription = timer(0, 5000).subscribe(() => {

          if (this.validatedAll) {

            this.postActionReset();

            this.grid?.refresh();

            if (this.data?.result && this.data?.result.length) {

              const nullStatuses = Array.from(this.data?.result)?.filter(x => !x['Validation Status']);

              if (nullStatuses && nullStatuses.length) {
                const ids = [];

                nullStatuses.forEach(element => {
                  ids.push({
                    documentId: element['id'],
                    dataScope: this.dataScope,
                    itemType: this.itemType
                  })
                });

                this.service.getValidationStatusMultiple(ids).subscribe(response => {

                  if (response && response.data && response.data.length) {
                    // get statuses
                    const updatedStatuses = Array.from(response.data)?.filter(x => x['status']);

                    if (updatedStatuses && updatedStatuses.length) {

                      updatedStatuses.forEach(element => {
                        const foundObject = Array.from(this.data.result).find(x => x['id'] === element['documentId']);

                        if (foundObject) {
                          foundObject['Validation Status'] = element['status'];

                          this.grid?.refresh();
                        }
                      });
                    } else {
                      this.validatedAll = false;
                    }
                  }
                });
              }
            }
          }
        });
      });
    }
    else {

      if (this.selectedItems && this.selectedItems.length) {
        this.createActionCompleted = false;

        const validations: IValidation[] = [];

        this.selectedItems.forEach((item) => {
          let registrationType = (this.dataScopeEudamed || this.dataScopeSwissdamed) && this.currentRegistrationTypeSelection === RegistrationTypeEnum.Legacy
            ? RegistrationTypeEnum.Legacy
            : RegistrationTypeEnum.Regulation;

          const validationItems: IValidationItem[] = [];

          const validation: IValidation = {

            customerId: this.customer.customerId,
            createUserGuid: this.userGuid,
            distributionChannel: this.dataScope,
            validationItems: validationItems
          };

          const validationItemDevice: IValidationItem = {

            validationId: '0',
            validationItemTypeCode: 'device',
            itemId: item['Primary DI'],
            itemIssuingAgency: item['Primary DI Issuing Agency'],
            revision: item['Device Revision'],
            registrationTypeCode: registrationType,
            documentId: item['id']
          };

          if (this.itemType === 'device') {
            validation.validationItems.push(validationItemDevice);
          }

          if (this.dataScopeEudamed || this.dataScopeSwissdamed) {

            const validationItemModel: IValidationItem = {

              validationId: '0',
              validationItemTypeCode: 'model',
              itemId: this.itemType === 'device' ? item['Basic UDI-DI Number'] : item['Basic UDI-DI'],
              itemIssuingAgency: item['Basic UDI-DI Issuing Agency'],
              revision: item['Model Revision'],
              registrationTypeCode: registrationType,
              documentId: this.itemType === 'model' ? item['id'] : null // Note: Null for the DEVICE scenario b/c the model's docId is not available to the device row at this point
            };

            validation.validationItems.push(validationItemModel);
          }

          // set the visual aknowledgement of the Validate to the current page. The other pages will be handled by the GetValidationMultiple
          if (this.data.result && this.data.result.length) {

            const validatedItemIndex = this.data.result.findIndex(x => x['id'] === item.id);

            if (validatedItemIndex >= 0) {
              this.data.result[validatedItemIndex]['Validation Status'] = '';
              (this.grid.getRows()[validatedItemIndex].querySelector('.e-templatecell .tooltip-span') as any).innerText = '';
            }
          }

          validations.push(validation);
        });

        if (validations && validations.length > 0) {

          let data$: Observable<Object | IServiceError>;

          data$ = this.service.validateSelectedDevices(validations, this.customer.customerId, this.DeterminePriorityId(validations.length));
          this.toastr.info('Your request has been submitted', '', { closeButton: true });
          this.subscription = data$.subscribe(data => {

            if (data && data['status'] === MessageSeverityEnum.success) {

              this.toastr.success(`Selected ${this.capitalize(this.itemType)}(s) successfully submitted for validation.`, '', { closeButton: true });
            } else {
              this.toastr.error(`Error validating ${this.capitalize(this.itemType)}(s)`, '', { timeOut: 0, closeButton: true });
            }
            this.createActionCompleted = true;
            this.grid?.refresh();
            setTimeout(() => this.grid?.refresh(), 50);
          });
        }

      } else {

        this.toastr.warning(`No ${this.capitalize(this.itemType)}(s) selected.`, '', { closeButton: true });
      }

      this.selectedItems = [];
      this.storage.write('selectedItems', this.selectedItems);
    }
  }

  DeterminePriorityId(numberOfItems: number) {
    if (numberOfItems <= 10) {
      return 1;
    }
    else if (numberOfItems <= 100) {
      return 2;
    }
    else if (numberOfItems > 100) {
      return 3;
    }
  }

  approveSelected() {

    if (this.checkIsSelected() || (this.selectedItems && this.selectedItems.length)) {
      this.modalVisible = true;
    } else {
      this.toastr.warning(`No ${this.capitalize(this.itemType)}(s) selected.`, '', { closeButton: true });
    }
  }

  keydownEnter(e) {
    const type = e.type;

    if (type === 'keydown' && (e.which === 13 || e.keyCode === 13)) {

      this.itemClicked(e);
    }
  }

  itemClicked(e) {

    let item;

    const diId = e.target.text.trim();

    const dataSource = this.grid.dataSource;

    if (dataSource && dataSource['result'] && dataSource['result'].length > 0) {

      if (this.itemType === 'model') {

        item = dataSource['result'].find(i => i['Basic UDI-DI'] === diId);
      } else {

        item = dataSource['result'].find(i => i['Primary DI'] === diId);
      }
    }

    if (item) {
      const revision = this.itemType === 'model' ? item['Model Revision'] : item['Device Revision'];
      const queryParams = revision ? { revision } : {};

      this.router.navigate(['/managedi/itemdetails', item.id], { queryParams });
    }
  }


  makeArrayUnique(arr): any[] {

    let uniqueArray = [];

    if (arr && arr.length) {

      uniqueArray = Array.from(new Map(arr.map(item => [item['name'], item])).values());
    }

    return uniqueArray;
  }

  // if some columns of the default columns miss the visibility property - add it.
  // It's needed for the correctly displaying the columns in the grid.
  fixDefaults(prefsToFix, defaultSetings) {

    let modifiedPrefs: any;
    let gridPrefs: any;

    // check defaults
    if (prefsToFix.channelGrids && prefsToFix.channelGrids.length) {

      // defaults for the appVarId
      modifiedPrefs = prefsToFix.channelGrids.find(x => x['applicationVariantId'] === this.appVarId);

      if (modifiedPrefs) {

        // fix both, model and device grids
        let grids = ['deviceGrid'];

        // If in the EUDAMED/SWISSDAMED ManageDI page while the 'eu-legacy-data-import' feature is enabled, we must consider the legacy grids.
        if (this.dataScope.toLowerCase() == 'eudamed' || this.dataScope.toLowerCase() == 'swissdamed') {
          grids.push('modelGrid');
          if (this.isLegacyImportFeatureEnabled) {
            grids.push('modelLegacyGrid');
            grids.push('deviceLegacyGrid');
          }
        }

        grids.forEach(grid => {
          gridPrefs = modifiedPrefs[grid];
          // check for the column in the defaults
          if (gridPrefs) {

            gridPrefs.defaultColumns = this.makeArrayUnique(gridPrefs.defaultColumns);
            gridPrefs.requiredColumns = this.makeArrayUnique(gridPrefs.requiredColumns);

            gridPrefs.defaultColumns.forEach(dcol => {

              // if a column found in the required column array, it always must be visible "true"
              if (gridPrefs.requiredColumns.findIndex(col => col.name === dcol.name) >= 0) {
                dcol.visible = true;
              }

              // if columns is found, even it doesn't have "visible" property (old prefs) it should be displayed/hidden
              // based on the visible property
              if (!dcol.hasOwnProperty('visible')) {
                dcol.visible = true;
              }

              // check if a column from savedPrefs exist in the defaultGridSettings because of the older settings may be different. Parameter indicates what prefs are getting "fixed". We are interested in the "saved" prefs.
              if (!defaultSetings) {
                const defaultChannelGrid = this.appDefaults.channelGrids.find(x => x['applicationVariantId'] === this.appVarId);
                const defaultGridPrefs = defaultChannelGrid[grid];
                const defaultGridDefaultColumns = this.makeArrayUnique(defaultGridPrefs.defaultColumns);

                if (dcol.name !== 'select') {
                  // check if the column from the saved prefs exist in the default columns list. If not remove it from the saved prefs.
                  const defaultColIndex = defaultGridDefaultColumns.findIndex(x => x.name === dcol.name);

                  if (defaultColIndex < 0) {

                    // column doesn't exist in the default columns file, remove it from the saved prefs
                    const colIndex = gridPrefs.defaultColumns.findIndex(x => x.name === dcol.name);

                    gridPrefs.defaultColumns.splice(colIndex, 1);
                  }
                }
              }
            });

            gridPrefs.requiredColumns.forEach(rcol => {

              // if columns is found, even it doesn't have "visible" property (old prefs) it should be displayed/hidden
              // based on the visible property
              if (!rcol.hasOwnProperty('visible')) {
                rcol.visible = true;
              }
            });

            prefsToFix.channelGrids.find(x => x['applicationVariantId'] === this.appVarId)[grid] = gridPrefs;
          };
        });
      }
    }

    return prefsToFix;
  }

  /**
   * Get app default settings from the resolver prepared data.
   * Default settings come from the \assets\griddefaults.json file.
   */
  getDefaultSettings() {

    // if there is no user settings yet, process app default settings instead
    // second element in array of data (pef forkJoin setup) is the appDefaults.
    if (this.resolverData && this.resolverData[1]) {
      this.appDefaults = this.resolverData[1];
      this.appDefaults = this.fixDefaults(this.appDefaults, true);
    }

    this.userPrefs = this.storage.read('userPrefs');

    // third element in array of data (pef forkJoin setup) is the userPrefs.
    if (this.resolverData && this.resolverData[2] && this.resolverData[2].message && this.resolverData[2].message.toLowerCase() === 'success') {

      if (!this.savedUserPrefs) {
        this.savedUserPrefs = this.resolverData[2].data;
      }

      // fix defaults to update to the new format with the "visible" property
      this.savedUserPrefs = this.fixDefaults(this.savedUserPrefs, false);

      // if user prefs already exist - don't override
      if (!this.userPrefs) {

        if (this.savedUserPrefs.channelGrids && this.savedUserPrefs.channelGrids.length) {

          this.userPrefObject = this.savedUserPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId);

          if (this.userPrefObject) {
            this.prefsPerGrid = this.userPrefObject[this.gridType];
          } else {
            this.savedUserPrefs = this.appDefaults;

            this.userPrefObject = this.savedUserPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId);
            this.prefsPerGrid = this.userPrefObject[this.gridType];
          }

          this.savedUserPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId)[this.gridType] = this.prefsPerGrid;
        } else {

          // user has old user prefs structure, replace with the default
          this.savedUserPrefs = this.appDefaults;

          this.userPrefObject = this.savedUserPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId);
          this.prefsPerGrid = this.userPrefObject[this.gridType];
        }

        // in case griddefaults contains different number of channels, use the appDefaults(gridDefaults.json) add/remove missing channels by creating a new unique array
        if (this.appDefaults.channelGrids && this.appDefaults.channelGrids.length) {
          this.appDefaults.channelGrids.forEach(grid => {
            if (this.savedUserPrefs.channelGrids.findIndex(x => x.applicationVariantId === grid.applicationVariantId) < 0) {
              this.savedUserPrefs.channelGrids.push(grid);
            }
          });
        }

        this.storage.write('userPrefs', this.savedUserPrefs);

      } else {

        this.getSessionUserPrefs();
      }
    } else {

      // if there are user prefs in the Application object get user pref, otherwise get appDefault prefs.
      if (this.userPrefs) {

        if (this.userPrefs.channelGrids && this.userPrefs.channelGrids.length) {

          this.userPrefObject = this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId);
        } else {

          // user has old user prefs structure, replace with the default
          this.userPrefObject = this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId);
        }
        this.prefsPerGrid = this.userPrefObject[this.gridType];

      } else {
        if (this.appDefaults) {
          this.userPrefObject = this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId);
          this.prefsPerGrid = this.userPrefObject[this.gridType];
        }
      }
    }
  }

  /**
* Every time the data state changes (resize, reorder, reload, etc.) this event gets triggered
* and originates the grid parameters. The parameter showInColumnChooser should be present
* for all columns in the columnOptions array. Default columns should be set to false to
* prevent the user from hiding them.
* Called from the html on the grid's dataStateChange event
* @param  {DataStateChangeEventArgs} state
* @returns void
*/
  public dataStateChange(state: DataStateChangeEventArgs): void {

    if (this.retrieveInDataState) {
      let filterRegistrationType = undefined;
      if (this.dataScope && (this.dataScope.toLowerCase() === 'eudamed' || this.dataScope.toLowerCase() === 'swissdamed') && this.isLegacyImportFeatureEnabled && this.currentRegistrationTypeSelection === RegistrationTypeEnum.Legacy) {
        filterRegistrationType = RegistrationTypeEnum.Legacy;
      }
      this.data$ = this.service.getData(state, this.grid, this.customer.customerId, this.itemType, this.dataScope, this.language, filterRegistrationType);

      this.subscription = this.data$.subscribe((response) => {
        this.data = response;

        this.setDeviceCounter();

        this.state = state;

        this.gridColumns = this.grid.columns;
      });
    } else {

      this.retrieveInDataState = true;
    }
  }

  private getSessionUserPrefs() {

    this.userPrefs = this.storage.read('userPrefs');

    if (this.userPrefs) {

      if (this.gridType === 'modelGrid') {
        this.prefsPerGrid = this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId).modelGrid;
      }
      // The userPrefs will not contain an entry for modelLegacyGrid/deviceLegacyGrid at first so use the defaults.
      else if (this.gridType === 'modelLegacyGrid') {
        this.prefsPerGrid = this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId).modelLegacyGrid
          ?? this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId).modelLegacyGrid;
      }
      else if (this.gridType === 'deviceLegacyGrid') {
        this.prefsPerGrid = this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId).deviceLegacyGrid
          ?? this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId).deviceLegacyGrid;
      }
      else {
        this.prefsPerGrid = this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId).deviceGrid;
      }
    } else {
      if (this.appDefaults) {
        this.userPrefs = this.appDefaults;
      }
    }
  }

  /**
   * Get and apply user preferences for the grid
   */
  private applyDefaultPrefs() {

    this.getDefaultSettings();

    this.defaultColumns = [];

    if (this.prefsPerGrid) {

      if (this.prefsPerGrid.defaultColumns && this.prefsPerGrid.defaultColumns.length > 0) {
        this.prefsPerGrid.defaultColumns.forEach(e => {

          if (e['name'] !== 'select' && e['visible']) {
            this.defaultColumns.push(e['name']);
          }
        });
      }
    }

    // Required columns should always be taken from the Default prefs, not the User Prefs
    this.requiredColumns = [];

    if (this.appDefaults.channelGrids) {

      if (this.gridType === 'modelGrid') {
        this.defaultPrefsPerGrid = this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId).modelGrid;
      }
      else if (this.gridType === 'modelLegacyGrid') {
        this.defaultPrefsPerGrid = this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId).modelLegacyGrid;
      }
      else if (this.gridType === 'deviceLegacyGrid') {
        this.defaultPrefsPerGrid = this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId).deviceLegacyGrid;
      }
      // Default scenario will use the deviceGrid
      else {
        this.defaultPrefsPerGrid = this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId).deviceGrid;
      }
    }

    if (this.defaultPrefsPerGrid) {
      if (this.defaultPrefsPerGrid.requiredColumns && this.defaultPrefsPerGrid.requiredColumns.length > 0) {
        this.defaultPrefsPerGrid.requiredColumns.forEach(e => {

          this.requiredColumns.push(e['name']);
        });
      }
    }

    if (this.grid && this.grid.columns && this.grid.columns.length > 0) {

      for (let index = 0; index < this.grid.columns.length; index++) {
        const col: any = this.grid.columns[index];

        if (col) {
          // Due to the griddefaults.json for Legacy grids not matching the deviceinventory .html file's fieldName attribute
          // we need to use the headerText property to properly find columns in the below logic.
          let value = this.gridType.includes('LegacyGrid') ? col.headerText : col.field;
          if (this.defaultColumns.includes(value)) {
            col.visible = true;
            if (col.type === null) {
              col.type = 'string';
            }
          }
          else {
            col.visible = false;
          }

          if (col.field.toLowerCase() === 'id') {
            col.visible = false;
            col.showInColumnChooser = false;
          }

          if (col.field === 'select') {
            col.visible = true;
            col.showInColumnChooser = false;
          }

          if (col.type === 'date') {
            col.format = { type: 'date', format: 'MM/dd/yyyy hh:mm a' };
          }
        }
      }
    }
  }

  isVisible(columnName): boolean {

    let visible;

    visible = this.defaultColumns.includes(columnName);

    return visible;
  }

  /**
   * Presets the column options and state for the execution based on the Item type
   * @param  {string} itemType
   */
  private preExecute(state: DataStateChangeEventArgs, itemType: string) {

    this.pageOptions = { pageSize: this.prefsPerGrid.defaultPageSize, pageCount: this.prefsPerGrid.pageCount, pageSizes: [25, 50, 100] };

    this.state = { skip: state && state.skip ? state.skip : 0, take: this.pageOptions['pageSize'], sorted: [] };

    if (this.prefsPerGrid.defaultColumns && this.prefsPerGrid.defaultColumns.length > 0) {

      const colAsc = this.prefsPerGrid.defaultColumns.find(c => c.sort.toLowerCase() === 'ascending');

      if (colAsc) {
        this.state.sorted.push({ name: colAsc.name, direction: colAsc.sort.toLowerCase() });
      }
    }
  }

  joinFieldArray(data, field): string {

    const fieldArray = data[field];

    if (fieldArray && fieldArray.length) {
      fieldArray.join('; ');
    }

    return fieldArray;
  }

  dataBound(args: any) {

    if (!this.hide) {
      this.hide = true;
    }

    // The grids in this component have the Menu filter enabled.
    // However, this filter contains an inbuilt autocomplete control
    // The code below creates a custom control to add a plain textbox instead of the autocomplete control.

    const inputObj = [];

    for (let i = 0; i < this.grid.columns.length; i++) {

      let filterBox: any;


      if ((this.grid.columns[i] as any).type === 'string' || (this.grid.columns[i] as any).type === null) {          // create textbox for string type column only
        (this.grid.columns[i] as any).filter.ui = {

          create: (args) => {

            const flValInput: HTMLElement = document.createElement('input');

            args.target.appendChild(flValInput);

            inputObj[args.column.field] = new TextBox({
              floatLabelType: 'Never',
            });
            inputObj[args.column.field].appendTo(flValInput);

            filterBox = args.target;
          },
          read: (args) => {

            let isSkip;
            let skipInput;

            if (args.column.type === 'string') {
              skipInput = ['>', '<', '=', '!'];

              for (let i = 0, value = args.element.value; i < value.length; i++) {
                let val = value[i];
                if (skipInput.indexOf(val) > -1) {
                  isSkip = true;
                }
              }
            }

            if (!isSkip) {
              args.fltrObj.filterByColumn(args.column.field, args.operator, args.element.value);
            } else {

              this.toastr.error('"< > = !" are not valid filter characters', '', { timeOut: 0, closeButton: true });
            }
          },
          write: (args) => {
            inputObj[args.column.field].value = args.filteredValue || '';
          }
        };
      }
    }

    if (this.initial && this.data && this.data.result && this.data.result.length > 0) {

      this.retrieveInDataState = true;

      this.initial = false;

      const firstHeader = document.getElementsByClassName('e-headercell')[0];

      if (firstHeader) {
        firstHeader.classList.add('checkbox-header-manage-di');
      }

    } else {

      (this.grid.getContent().parentElement as any).style.display = '';

      if (this.initial && this.data && this.data.count === 0 && this.grid && this.grid.columns && this.grid.columns.length > 0) {

        this.initial = false;
      }
    }

    this.setDeviceCounter();
    this.toolbarButtonAccess();
  }

  /**
   * Store user prefs in sessionStorage for reloading and changing tabs.
   * When "Save Grid Preferences" is clicked this sessionStorage object will be passed to SettingService
   */
  storeUserPrefs() {
    this.userPrefs = this.storage.read('userPrefs');
    this.userGuid = this.storage.read('userGuid');

    if (!this.userPrefs) {

      if (this.savedUserPrefs) {

        if (this.appDefaults.channelGrids && this.appDefaults.channelGrids.length) {
          this.appDefaults.channelGrids.forEach(grid => {
            if (this.savedUserPrefs.channelGrids.findIndex(x => x.applicationVariantId === grid.applicationVariantId) < 0) {
              this.savedUserPrefs.channelGrids.push(grid);
            }
          });
        }

        this.userPrefs = this.savedUserPrefs;
      } else {

        this.userPrefs = this.appDefaults;
      }
    }

    let userColumnsObjects: Column[] = [];

    // empty array every time before adding columns
    this.userColumns = [];

    this.userPrefs.userId = this.userGuid;
    this.userPrefs.configurationType = 'UserConfig';

    if (this.grid && this.grid.columns) {

      this.gridComplete = true;

      userColumnsObjects = (this.grid.columns as Array<Column>);

      if (userColumnsObjects && userColumnsObjects.length > 0) {

        userColumnsObjects.forEach((col, i) => {

          const column = { name: '', sort: '', seq: 0, visible: true };

          // EUDAMED Legacy columns must use the headerText
          if ((this.dataScope.toLowerCase() === 'eudamed' || this.dataScope.toLowerCase() === 'swissdamed') && this.isLegacyImportFeatureEnabled && this.currentRegistrationTypeSelection === RegistrationTypeEnum.Legacy) {
            column.name = col.headerText;
          }
          else {
            column.name = col.field;
          }

          column.seq = i;

          column.visible = col.visible;

          this.userColumns.push(column);
        });
      }

      // Add the legacy grids if they are not present in the userPrefs
      if (this.dataScope === 'eudamed' || this.dataScope === 'swissdamed' && this.isLegacyImportFeatureEnabled) {
        let eudamedGrids = this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId);
        let appDefaultEudamedGrid = this.appDefaults.channelGrids.find(a => a.applicationVariantId === this.appVarId);
        let legacyGrids = ['modelLegacyGrid', 'deviceLegacyGrid'];
        legacyGrids.forEach(legacyGrid => {
          if (!eudamedGrids.hasOwnProperty(legacyGrid)) {
            this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId)[legacyGrid] = appDefaultEudamedGrid[legacyGrid];
          }
        });
      }

      let possibleGrids = ['modelGrid', 'deviceGrid'];
      if ((this.dataScope === 'eudamed' || this.dataScope === 'swissdamed') && this.isLegacyImportFeatureEnabled) {
        possibleGrids.push('modelLegacyGrid');
        possibleGrids.push('deviceLegacyGrid');
      }
      let allGridsButThisOne = possibleGrids.filter(x => x !== this.gridType);

      this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId)[this.gridType].defaultColumns = [];
      this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId)[this.gridType].defaultColumns = this.userColumns;
      this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId)[this.gridType].defaultPageSize = this.state.take;

      // keep the other grid prefs, otherwise the app default is selected
      allGridsButThisOne.forEach(grid => {
        const gridConfig = this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId)[grid];
        if (gridConfig && gridConfig.defaultColumns) {
          this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId)[grid].defaultColumns = gridConfig.defaultColumns;
        }
        if (gridConfig && gridConfig.defaultPageSize) {
          this.userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId)[grid].defaultPageSize = gridConfig.defaultPageSize;
        }
      });

      this.storage.write('userPrefs', this.userPrefs);
    }
  }
  /**
   * Triggers when any grid action begins
   * @param  {any} args
   */
  actionBegin(args: any) {

    const type = args.requestType;

    switch (type) {
      case 'paging':
        this.storeSelectedEntireItems();
        break;

      case 'filterbeforeopen':

        break;

      default:
        break;
    }
  }

  /**
   * Triggers when any grid action taken (sort, page, rows/per page number)
   * Called from the html actionComplete event
   * @param  {any} args
   */
  complete(args: any) {

    switch (args.requestType) {
      case 'reorder':

        this.storeUserPrefs();

        if (!this.selectAllChecked && !this.deselectAllChecked) {
          this.persistSelectedItems();
        }

        // if SelectAll is selected - select rows on the page on paging event
        if (this.selectAllChecked) {
          this.selectRowsAll(this.selectAllChecked);
        }

        break;
      case 'refresh':

        this.setDeviceCounter();

        this.refreshCount++;

        this.gridComplete = this.refreshCount >= 2 || this.deviceCount === 0;

        this.toolbarButtonAccess();

        break;
      case 'columnstate':

        this.storeUserPrefs();
        break;
      case 'filtering':

        if (this.grid && this.grid.columns && this.grid.columns.length > 0) {
          this.setDeviceCounter();

          this.selectRowsAll(false);
        }
        break;
      case 'sorting':

        this.storeUserPrefs();
        break;

      case 'paging':

        if (!this.selectAllChecked && !this.deselectAllChecked) {
          this.persistSelectedItems();
        }

        // if SelectAll is selected - select rows on the page on paging event
        if (this.selectAllChecked) {
          this.selectRowsAll(this.selectAllChecked);
        }

        // if SelectAll is intentionally unchecked - unselect rows - overrides persistance
        if (this.deselectAllChecked) {
          this.selectRowsAll(false);
        }

        break;
      case 'filterafteropen':

        if (args.columnType === 'date') {
          args.filterModel.dlgDiv.querySelector(
            '.e-datepicker'
          ).ej2_instances[0].format = 'MM/dd/y';
        }
        break;
    }
  }
  toolbarButtonAccess() {


    this.permitted = this.authorizationService.hasPermission(this.permissionsConst.CanSendDataForSubmissionApproval);
    this.canUpdateRecord = this.authorizationService.hasPermission(this.permissionsConst.CanUpdateRecord);

    const toolbarItems: any[] = [];

    if (!this.shouldHideBulkActionsForSwissdamedModel()) {
      toolbarItems.push({ text: 'Validate', id: 'validateselected', prefixIcon: 'far fa-check' });
    }

    if (this.shouldShowSendForApprovalToolbarButton()) {
      toolbarItems.push({ template: this.toolbarSubmitTemplate, id: 'approveselected' });
    }

    if (this.shouldShowSetHaStateToolbarButton()) {
      toolbarItems.push({ template: this.setHaStateTemplate, id: this.setHaStateToolbarId });
    }

    if (!this.shouldHideBulkActionsForSwissdamedModel()) {
      toolbarItems.push({ template: this.toolbarDownloadLogTemplate, id: 'downloadlog' });
    }

    toolbarItems.push('ColumnChooser');

    this.toolbar = toolbarItems;
  }

  shouldShowSendForApprovalToolbarButton(): boolean {
    return this.permitted && !this.shouldHideBulkActionsForSwissdamedModel();
  }

  shouldHideBulkActionsForSwissdamedModel(): boolean {
    return this.dataScopeSwissdamed
      && this.itemType === 'model'
      && (this.currentRegistrationTypeSelection === RegistrationTypeEnum.Legacy
        || this.currentRegistrationTypeSelection === RegistrationTypeEnum.Regulation);
  }

  shouldShowSelectAllCheckbox(): boolean {
    return this.deviceCount > 0 && this.shouldAllowRowSelection();
  }

  shouldAllowRowSelection(): boolean {
    return !this.shouldHideBulkActionsForSwissdamedModel();
  }

  shouldShowSelectedCount(): boolean {
    return this.getSelectedItemsCount() > 0 && this.shouldAllowRowSelection();
  }

  shouldShowSetHaStateToolbarButton(): boolean {
    return this.canUpdateRecord && this.dataScopeEudamed && this.itemType === 'device';
  }

  canSetSelectedHaState(): boolean {
    return !!this.getSelectedHaStateTarget();
  }

  getHaStateActionTooltipText(): string {
    if (this.selectAllChecked || this.getSelectedItemsCount() > 1) {
      return 'Multi-selection is not supported for this feature. Select one record to continue.';
    }

    return '';
  }

  canChangeSelectedHaStateFrom(requiredState: string): boolean {
    const selectedRecord = this.getSingleSelectedHaStateRecord();
    const normalizedRequiredState = (requiredState || '').trim().toLowerCase();

    return this.shouldShowSetHaStateToolbarButton()
      && !this.selectAllChecked
      && !!selectedRecord
      && this.getNormalizedHealthAuthorityState(selectedRecord) === normalizedRequiredState;
  }

  getSingleSelectedHaStateRecord(): any {
    const storedSelectedItems = this.storage.read('selectedItems');
    const selectedItems = storedSelectedItems && storedSelectedItems.length
      ? storedSelectedItems
      : this.selectedItems;

    if (selectedItems && selectedItems.length > 1) {
      return null;
    }

    const selectedGridRecords = this.getSelectedGridRecords();

    if (selectedGridRecords.length === 1) {
      return selectedGridRecords[0];
    }

    if (!selectedItems || selectedItems.length !== 1) {
      return null;
    }

    return this.resolveSelectedHaStateRecord(selectedItems[0]);
  }

  resolveSelectedHaStateRecord(selectedItem: any): any {
    if (selectedItem && typeof selectedItem === 'object') {
      return selectedItem;
    }

    return this.getCurrentViewRecordById(selectedItem);
  }

  getSelectedGridRecords(): any[] {
    if (!this.grid || !this.grid.getSelectedRows || !this.grid.getSelectedRecords) {
      return [];
    }

    const selectedRows = this.grid.getSelectedRows();

    if (!selectedRows || selectedRows.length !== 1) {
      return [];
    }

    const selectedRecords = this.grid.getSelectedRecords();

    return selectedRecords && selectedRecords.length === 1 ? selectedRecords : [];
  }

  getCurrentViewRecordById(id: any): any {
    if (!id || !this.grid || !this.grid.getCurrentViewRecords) {
      return null;
    }

    const records = this.grid.getCurrentViewRecords();

    if (!records || !records.length) {
      return null;
    }

    return records.find(record => record['id'] === id) || null;
  }

  getHealthAuthorityState(record: any): string {
    if (!record) {
      return '';
    }

    return this.itemType === 'model'
      ? record['Health Authority Basic UDI-DI State']
      : record['Health Authority UDI-DI State'];
  }

  getNormalizedHealthAuthorityState(record: any): string {
    return (this.getHealthAuthorityState(record) || '').trim().toLowerCase();
  }

  isDiscardedHaState(state: string): boolean {
    const stateValue = (state || '').toLowerCase();

    return stateValue === 'discarded' || stateValue === 'deleted';
  }

  hasDiscardedSubmissionSelection(): boolean {
    if (!this.dataScopeEudamed || this.selectAllChecked) {
      return false;
    }

    const selectedItems = this.storage.read('selectedItems') || this.selectedItems;

    return !!selectedItems && selectedItems.some(item => this.isDiscardedHaState(this.getHealthAuthorityState(item)));
  }

  openSetHaStateDialog(): void {
    const target = this.getSelectedHaStateTarget();

    if (!target) {
      this.toastr.warning('Select one EUDAMED device record with a Registered or Submitted HA state.', '', { closeButton: true });
      return;
    }

    this.openHaStateChangeDialog(target.stateCode, target.state, target.action);
  }

  getSelectedHaStateTarget(): { stateCode: number, state: string, action: string } | null {
    const selectedRecord = this.getSingleSelectedHaStateRecord();

    if (!this.shouldShowSetHaStateToolbarButton() || this.selectAllChecked || !selectedRecord) {
      return null;
    }

    switch (this.getNormalizedHealthAuthorityState(selectedRecord)) {
      case 'registered':
        return { stateCode: 19, state: 'Discarded', action: 'discard' };
      case 'submitted':
        return { stateCode: 20, state: 'Deleted', action: 'delete' };
      default:
        return null;
    }
  }

  openHaStateChangeDialog(targetStateCode: number, targetState: string, targetAction: string): void {
    const requiredCurrentState = targetStateCode === 20 ? 'submitted' : 'registered';
    const requiredStateLabel = requiredCurrentState.charAt(0).toUpperCase() + requiredCurrentState.slice(1);

    if (!this.canChangeSelectedHaStateFrom(requiredCurrentState)) {
      this.toastr.warning(`Select one EUDAMED device record with a ${ requiredStateLabel } HA state.`, '', { closeButton: true });
      return;
    }

    this.haStateTargetStateCode = targetStateCode;
    this.haStateTargetState = targetState;
    this.haStateTargetAction = targetAction;
    this.haStateSelectedRecord = this.getSingleSelectedHaStateRecord();
    this.haStateReason = '';
    this.haStateRequestedBy = '';
    this.haStateServiceTicket = '';
    this.haStateValidationMessage = '';
    this.haStateLinkedDeviceCount = null;
    this.haStateCascadeModel = false;

    if (this.itemType === 'device' && this.getModelIdentifier(this.haStateSelectedRecord) && this.getModelIssuingAgency(this.haStateSelectedRecord)) {
      this.service.getLinkedDeviceCountForModel(
        this.customer.customerId,
        this.dataScope,
        this.getModelIdentifier(this.haStateSelectedRecord),
        this.getModelIssuingAgency(this.haStateSelectedRecord),
        this.currentRegistrationTypeSelection,
        requiredStateLabel
      ).subscribe(response => {
        this.haStateLinkedDeviceCount = this.getLinkedDeviceCountValue(response);

        if (this.haStateLinkedDeviceCount === null) {
          this.showLinkedDeviceCountError();
          return;
        }

        this.haStateCascadeModel = this.haStateLinkedDeviceCount === 1;
        this.discardHaStateDialogVisible = true;
      }, () => {
        this.showLinkedDeviceCountError();
      });
    } else {
      this.discardHaStateDialogVisible = true;
    }
  }

  getLinkedDeviceCountValue(response: any): number | null {
    const value = response?.value?.data
      ?? response?.Value?.Data
      ?? response?.data
      ?? response?.Data
      ?? response;
    const count = Number(value);

    return Number.isFinite(count) ? count : null;
  }

  showLinkedDeviceCountError(): void {
    this.haStateLinkedDeviceCount = null;
    this.haStateCascadeModel = false;
    this.discardHaStateDialogVisible = false;
    this.toastr.error('Unable to verify linked device count for the selected model. Try again or contact support.', '', { timeOut: 0, closeButton: true });
  }

  confirmDiscardHaState(): void {
    this.haStateValidationMessage = '';

    if (!this.haStateReason || !this.haStateReason.trim()) {
      this.haStateValidationMessage = 'Reason is required.';
      return;
    }

    if (!this.haStateRequestedBy || !this.haStateRequestedBy.trim()) {
      this.haStateValidationMessage = 'Requested By is required.';
      return;
    }

    const request = {
      customerId: this.customer.customerId,
      distributionChannelCode: 2,
      itemTypeCode: 1,
      itemIdentifier: this.haStateSelectedRecord['Primary DI'],
      itemIssuingAgency: this.haStateSelectedRecord['Primary DI Issuing Agency'],
      registrationType: this.currentRegistrationTypeSelection,
      newHealthAuthorityStateCode: this.haStateTargetStateCode,
      reason: this.haStateReason.trim(),
      requestedBy: this.haStateRequestedBy.trim(),
      serviceTicket: this.haStateServiceTicket ? this.haStateServiceTicket.trim() : null,
      changeUserGuid: this.userGuid,
      cascadeModel: this.haStateCascadeModel,
      modelIdentifier: this.haStateCascadeModel ? this.getModelIdentifier(this.haStateSelectedRecord) : null,
      modelIssuingAgency: this.haStateCascadeModel ? this.getModelIssuingAgency(this.haStateSelectedRecord) : null
    };

    this.haStateChangeInProgress = true;

    this.service.discardHealthAuthorityState(request, this.customer.customerId).subscribe(response => {
      const changes = response?.value?.data ?? response?.data ?? response;
      this.applyManualHaStateChangeToGrid(changes);
      this.toastr.success('Your request was received and queued for processing.', '', { closeButton: true });
      this.closeDiscardHaStateDialog();
      this.clearGridSelection();
      this.toolbarButtonAccess();
    }, (error) => {
      this.haStateChangeInProgress = false;
      this.toastr.error(this.getHaStateChangeErrorMessage(error), '', { timeOut: 0, closeButton: true });
    });
  }

  getHaStateChangeErrorMessage(error: any): string {
    const detail = error?.errorMessage || '';

    return detail
      ? `Unable to update HA state. ${detail}`
      : 'Unable to update HA state.';
  }

  closeDiscardHaStateDialog(): void {
    this.discardHaStateDialogVisible = false;
    this.haStateChangeInProgress = false;
    this.haStateValidationMessage = '';
  }

  applyManualHaStateChangeToGrid(changes: any): void {
    const changeList = Array.isArray(changes) ? changes : [];
    const targetState = this.haStateTargetState;

    if (this.haStateSelectedRecord) {
      if (this.itemType === 'model') {
        this.haStateSelectedRecord['Health Authority Basic UDI-DI State'] = targetState;
      } else {
        this.haStateSelectedRecord['Health Authority UDI-DI State'] = targetState;
      }
    }

    if (this.data?.result && changeList.length) {
      changeList.forEach(change => {
        const fieldName = change.itemTypeCode === 2 || change.ItemTypeCode === 2
          ? 'Health Authority Basic UDI-DI State'
          : 'Health Authority UDI-DI State';
        const identifier = change.itemIdentifier || change.ItemIdentifier;
        const issuingAgency = change.itemIssuingAgency || change.ItemIssuingAgency;
        const newState = change.newHealthAuthorityState || change.NewHealthAuthorityState || targetState;

        const row = Array.from(this.data.result).find((x: any) =>
          (x['Primary DI'] === identifier && x['Primary DI Issuing Agency'] === issuingAgency)
          || (this.getModelIdentifier(x) === identifier && this.getModelIssuingAgency(x) === issuingAgency));

        if (row) {
          row[fieldName] = newState;
        }
      });
    }

    this.grid?.refresh?.();
  }

  getModelIdentifier(record: any): string {
    if (!record) {
      return '';
    }

    return this.itemType === 'model' && record['Basic UDI-DI']
      ? record['Basic UDI-DI']
      : record['Basic UDI-DI Number'];
  }

  getModelIssuingAgency(record: any): string {
    return record ? record['Basic UDI-DI Issuing Agency'] : '';
  }

  saveUserPrefs() {

    const userPrefs = this.storage.read('userPrefs');

    if (userPrefs) {

      // sorting should not be saved in the prefs and therefore the initial sorting will be
      // the default one - by modifiedDateTime desc
      const modelGrid = userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId).modelGrid;
      if (modelGrid && modelGrid.defaultColumns) {
        modelGrid.defaultColumns.forEach(col => {
          col.sort = 'Descending';
        });
      }

      const deviceGrid = userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId).deviceGrid;
      if (deviceGrid && deviceGrid.defaultColumns) {
        deviceGrid.defaultColumns.forEach(col => {
          col.sort = 'Descending';
        });
      }

      // Handle the default sort for Legacy grids only for EUDAMED with feature enabled
      if (this.dataScope === 'eudamed' || this.dataScope === 'swissdamed' && this.isLegacyImportFeatureEnabled) {
        const modelLegacyGrid = userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId).modelLegacyGrid;
        if (modelLegacyGrid && modelLegacyGrid.defaultColumns) {
          modelLegacyGrid.defaultColumns.forEach(col => {
            col.sort = 'Descending';
          });
        }

        const deviceLegacyGrid = userPrefs.channelGrids.find(a => a.applicationVariantId === this.appVarId).deviceLegacyGrid;
        if (deviceLegacyGrid && deviceLegacyGrid.defaultColumns) {
          deviceLegacyGrid.defaultColumns.forEach(col => {
            col.sort = 'Descending';
          });
        }
      }

      if (this.prefsPerGrid && this.prefsPerGrid.defaultColumns) {
        this.prefsPerGrid.defaultColumns.forEach(col => {
          col.sort = 'Descending';
        });
      }

      this.userGuid = this.storage.read('userGuid');

      this.service.saveUserPrefs(userPrefs).subscribe(res => {
        const result = res['message'];

        if (result && result.toLowerCase() === 'success') {

          this.toastr.success('Preferences saved successfully', '', { closeButton: true });

          this.storage.remove('userPrefs');

        } else {

          this.toastr.error('Preferences not saved.', '', { timeOut: 0, closeButton: true });
        }
      });
    } else {
      this.toastr.info('Preferences haven not been modified. The default preferences remain.', '', { closeButton: true });
    }
  }
  /**
     * Handle grid created event - handles data loading for both initial load and tab switches
     * @param  {} event
     */
  gridCreated(event) {

    this.columnChooserOpen();
    // Only fetch here when the grid is recreated after a tab switch.
    if (!this.tabSwitched) {
      return;
    }

    this.tabSwitched = false;
    this.data$ = this.service.getData(this.state, this.grid, this.customer.customerId, this.itemType, this.dataScope, this.language, this.currentRegistrationTypeSelection);

    this.subscription = this.data$.subscribe((response) => {
      this.retrieveInDataState = true;
      this.data = response;
      this.setDeviceCounter();
      this.applyDefaultPrefs();
      this.buildColumnsPositionArray();
      this.reorderColumns();
    });
  }
  /**
   * Preset grid state, column options, etc when the Item type tab has changed.
   * @param  {} event
   */
  tabChanged(event) {

    // variable to initialize the ColumnChooser
    this.initialLoad = true; // Needed to kick off the columnChooserOpened event so that we may configure the column selector options.
    this.selectedItems = [];
    this.storage.write('selectedItems', this.selectedItems);
    this.initial = true;
    this.selectAllChecked = false;
    this.storage.write('activeTab', event.nextId);
    this.activeTab = event.nextId;

    this.deviceCount = -1;
    this.refreshCount = 1; // need to increase to maintain gridComplete.
    this.gridComplete = false;
    this.itemType = event.nextId;
    this.gridType = this.itemType === 'model' ? 'modelGrid' : 'deviceGrid';

    if ((this.dataScope.toLowerCase() === 'eudamed' || this.dataScope.toLowerCase() === 'swissdamed') && this.isLegacyImportFeatureEnabled && this.currentRegistrationTypeSelection == RegistrationTypeEnum.Legacy) {
      this.gridType = `${this.itemType}LegacyGrid`;
    }

    this.state = {};
    this.grid.columns = [];
    this.data = null;
    this.validatedAll = false;

    this.preExecute(this.state, this.itemType);

    // flag to indicate tab was switched 
    this.tabSwitched = true;
  }


  buildColumnsPositionArray() {

    let columns: string[] = [];
    let gridColumns: any[] = [];

    this.position = [];

    this.applyDefaultPrefs();

    this.userPrefs = this.storage.read('userPrefs');

    if (!this.defaultColumns || (this.defaultColumns && this.defaultColumns.length === 0)) {

      if (this.prefsPerGrid.defaultColumns && this.prefsPerGrid.defaultColumns.length > 0) {
        this.prefsPerGrid.defaultColumns.forEach(e => {
          this.defaultColumns.push(e['name']);
        });
      }

      columns = this.defaultColumns;
    } else {

      columns = this.defaultColumns;
    }

    let columnPositionInGrid: number;

    // First position is a checkbox
    this.position.push(0);

    if (this.grid && this.grid.columns && this.grid.columns.length > 0) {

      gridColumns = this.grid.columns;

      if (columns && columns.length > 0 && gridColumns && gridColumns.length > 0) {

        columns.forEach(columnName => {

          // First position is for the checkbox, start from the second position
          for (let index = 1; index < gridColumns.length; index++) {

            const gridCol = gridColumns[index];

            let valueToCheck = this.gridType.includes('LegacyGrid') ? gridCol.headerText : gridCol.field;
            if (gridCol && valueToCheck === columnName) {
              columnPositionInGrid = gridColumns.indexOf(gridCol);

              if (columnPositionInGrid && columnPositionInGrid > -1) {
                this.position.push(columnPositionInGrid);
              }
            }
          }
        });
      }
    }
  }

  reorderColumns() {

    let gridColumns: any[] = [];

    if (this.grid && this.grid.columns && this.grid.columns.length > 0) {

      gridColumns = this.grid.columns;

      if (gridColumns && gridColumns.length > 0) {
        const remainingColumns = gridColumns.filter(c => c.visible === false);

        const requiredColumns = [];

        if (this.grid && this.grid.columns && this.grid.columns.length > 0) {

          this.position.forEach((value, index) => {
            requiredColumns[index] = this.grid.columns[value];
          });
          this.grid.columns = requiredColumns.concat(remainingColumns);
        }
      }
    }

    if (this.initial) {
      this.retrieveInDataState = false;
    }
  }

  getDownloadInProgress(): boolean {

    const retVal = this.service.manageDiDownloadLogBS.getValue();

    return retVal;
  }

  persistSelectedItems() {

    this.grid.selectRows([]);

    const selectedItemIndexes: number[] = [];

    const selectedItems = this.storage.read('selectedItems');

    if (selectedItems && selectedItems.length > 0) {

      const gridObj = this.grid;

      const records = gridObj.getCurrentViewRecords();

      selectedItems.forEach(item => {

        const rowIndex = records.findIndex(r => r['id'] === item.id);

        if (rowIndex >= 0) {
          selectedItemIndexes.push(rowIndex);
        }
      });

      if (selectedItemIndexes.length > 0) {

        this.grid.selectRows(selectedItemIndexes);
      }
    }
  }

  storeSelectedEntireItems() {

    // for some reason getSelectedRecords() returns all visible rows, even if nothing is selected
    // however the getSelectedRows() returns correctly the selected rows but not it the structure we need from the getSelectedRecords()
    // So, need to check the getSelectedRows to make sure that rows have been selected. Looks like Syncfusino bug. When any row is really selected,
    // both function return correct number of rows.

    if (this.grid.getSelectedRows() && this.grid.getSelectedRows().length) {
      const selectedRecords = this.grid.getSelectedRecords();

      if (selectedRecords.length > 0) {

        // add selected records
        selectedRecords.forEach(element => {

          if (!this.selectedItems.find(x => x.id === element['id'])) {
            this.selectedItems.push(element);
          }
        });
      }

      this.storage.write('selectedItems', this.selectedItems);
    } else {

      // when no rows selected the above block is skipped and the storage is not updated and previously selected rows are persisted.
      let storedSelectedItems = this.storage.read('selectedItems');

      // get records on the page and remove each of them from the storage so they are not persisted
      const records = this.grid.getCurrentViewRecords();

      if (records && records.length) {
        records.forEach(item => {

          const rowIndex = storedSelectedItems.findIndex(x => x === item['id']);

          if (rowIndex >= 0) {
            storedSelectedItems.splice(rowIndex, 1)
          }
        });
      }

      // update the storage
      this.storage.write('selectedItems', storedSelectedItems);
    }
  }

  rowSelectedItem(event, field) {

    if (event.isInteracted) {

      if (!this.selectAllChecked) {
        if (event && event.data) {

          // multiple selection
          if (event.data.length) {

            event.data.forEach(item => {
              if (!this.selectedItems.find(x => x.id === event.data[field])) {
                this.selectedItems.push(item);
              }
            });

            this.storage.write('selectedItems', this.selectedItems);
          } else {

            if (!this.selectedItems.find(x => x.id === event.data[field])) {
              this.selectedItems.push(event.data);

              this.storage.write('selectedItems', this.selectedItems);
            }
          }
        }
      }
    }

    this.toolbarButtonAccess();
  }

  rowDeselectedItem(event, field) {

    if (event.isInteracted) {
      if (!this.selectAllChecked) {

        this.selectedItems = this.storage.read('selectedItems');

        if (this.selectedItems && this.selectedItems.length > 0) {

          // multiple selection
          if (event.data.length) {

            event.data.forEach(item => {
              const rowIndex = this.selectedItems.findIndex(x => x['id'] === item[field])

              if (rowIndex >= 0) {
                this.selectedItems.splice(rowIndex, 1);
              }
            });
          } else {
            // single item
            const rowIndex = this.selectedItems.findIndex(x => x['id'] === event.data[field])

            if (rowIndex >= 0) {
              this.selectedItems.splice(rowIndex, 1);
            }
          }

          this.storage.write('selectedItems', this.selectedItems);
        }
      }
    }

    this.toolbarButtonAccess();
  }

  downloadLog() {

    let fileName: string;
    let downloadLogTaskGuid;

    const items: object[] = [];

    // Prevent the user from attempting to kick off another Log download in the event they get impatient.
    if (this.service.manageDiDownloadLogBS.getValue()) {
      this.toastr.warning("Please wait, a download is currently in progress.")
      return;
    }

    if (this.selectAllChecked) {

      // This call will return the guid that will be used later to check the download progress.
      // call 1, with or without filter. Get back guid.
      // call 2, checkDownloadProgress ( guid). Get "isDownloading=true/false", file name, success/fail, if there are chunks I get total number of chunks and chunks completed.
      this.downloadInProgress = true;
      this.service.manageDiDownloadLogBS.next(this.downloadInProgress);

      let filter = this.getFilterCriteria();

      this.postActionReset();

      // call 1, with or without filter. Get back guid.
      this.service.downloadValidationLogAll(this.itemType, this.dataScope, this.currentRegistrationTypeSelection, filter).subscribe(response => {

        if (response['isSuccess'] && response['data']) {

          downloadLogTaskGuid = response['data'];

          // the loading process has started
          if (downloadLogTaskGuid) {

            // Initiate the download process timer
            this.downloadTimerSubscription = timer(0, this.timerInterval).subscribe(() => {

              let responseData;
              let dowloadProgressStatus = 0;

              this.service.getDownloadLogStatus(downloadLogTaskGuid).subscribe(response => {

                // check data if success
                if (response['isSuccess'] && response['data']) {

                  responseData = response['data'];
                  dowloadProgressStatus = responseData['statusCode'];

                  // variable to stop "dancing dots" on the toolbar button
                  this.downloadInProgress = dowloadProgressStatus !== ExportStatusEnum.Completed && dowloadProgressStatus !== ExportStatusEnum.Exception;
                  this.service.manageDiDownloadLogBS.next(this.downloadInProgress);

                  // if status is either completed or exception stop sending http calls, unsubscribe.
                  if (dowloadProgressStatus === ExportStatusEnum.Completed || dowloadProgressStatus === ExportStatusEnum.Exception) {

                    this.downloadInProgress = false;
                    this.service.manageDiDownloadLogBS.next(this.downloadInProgress);

                    // completed or exception - unsubscribe and reset
                    // file is created, stop checking
                    if (this.downloadTimerSubscription) {
                      this.downloadTimerSubscription.unsubscribe();
                    }

                    if (dowloadProgressStatus === ExportStatusEnum.Completed) {

                      // task completed, get the file from the location
                      this.downloadLogFile(responseData['fileName'], responseData['filePath']);
                    }


                    if (dowloadProgressStatus === ExportStatusEnum.Exception) {

                      this.toastr.error(`Error downloading Validation Log`, '', { timeOut: 0, closeButton: true });
                    }

                  }
                }
              })

            }
            );
          }
        } else {
          this.toastr.error(`Error downloading Validation Log`, '', { timeOut: 0, closeButton: true });
        }

      });

    } else {

      // for a manual row selection
      if (this.selectedItems && this.selectedItems.length) {

        const today = new Date();

        fileName = `ValidationLog_${String(today.getFullYear()).padStart(2, '0')}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}${String(today.getHours()).padStart(2, '0')}${String(today.getMinutes()).padStart(2, '0')}.csv`;

        this.selectedItems = this.storage.read('selectedItems');

        if (this.selectedItems && this.selectedItems.length) {

          this.selectedItems.forEach(selectedItem => {

            const item = {};

            if (selectedItem) {
              item['identifier'] = this.itemType === 'model' ? selectedItem['Basic UDI-DI'] : selectedItem['Primary DI'];
              item['agency'] = this.itemType === 'model' ? selectedItem['Basic UDI-DI Issuing Agency'] : selectedItem['Primary DI Issuing Agency'];
              item['revision'] = this.itemType === 'model' ? selectedItem['Model Revision'] : selectedItem['Device Revision'];
              item['registrationType'] = this.currentRegistrationTypeSelection;

              items.push(item);
            }
          });
        }

        if (items.length > 0) {

          const paramsContainer = {
            validationLogInputs: items,
            customerId: this.customer.customerId,
            channel: this.dataScope,
            reportFilename: fileName,
            reportFormat: 'CSV'
          };

          this.downloading = true;

          this.service.getValidationLog(paramsContainer)
            .subscribe(response => {

              if (response['size'] && response['type']) {

                // IE
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                  (window.navigator as any).msSaveOrOpenBlob(response, fileName);
                } else {

                  // non-IE
                  const URL = window.URL || (<any>window).webkitURL;
                  const downloadUrl = URL.createObjectURL(response);
                  const link = document.createElement('a');
                  link.href = downloadUrl;
                  link.download = fileName;
                  link.click();

                  this.downloading = false;
                }
              } else {

                this.toastr.error(`Error downloading Validation Log`, '', { timeOut: 0, closeButton: true });
              }
            });

          this.clearGridSelection();
        }
      } else {

        this.toastr.warning(`No ${this.capitalize(this.itemType)}(s) selected.`, '', { closeButton: true });
      }
    }

  }


  createSubmissionItems(event) {

    if (this.selectAllChecked) {

      this.submittedAll = false;

      let registrationTypeCode = (this.dataScopeEudamed || this.dataScopeSwissdamed) && this.currentRegistrationTypeSelection === RegistrationTypeEnum.Legacy
        ? RegistrationTypeEnum.Legacy
        : RegistrationTypeEnum.Regulation;

      let filter = this.getFilterCriteria();

      this.service.submitSelectedAll(this.itemType, this.dataScope, filter, registrationTypeCode).subscribe(data => {
        this.submittedAll = data['isSuccess'];

        this.toastr.success(`${this.getSelectedItemsCount()} ${this.itemType}(s) were successfully sent for approval.`, '', { closeButton: true });

        this.postActionReset();
      });

    } else {

      const submissions: ISubmission[] = [];

      if (this.selectedItems && this.selectedItems.length) {

        let registrationTypeCode = (this.dataScopeEudamed || this.dataScopeSwissdamed) && this.currentRegistrationTypeSelection === RegistrationTypeEnum.Legacy ? RegistrationTypeEnum.Legacy : RegistrationTypeEnum.Regulation;

        this.selectedItems.forEach(item => {

          const submissionItems: ISubmissionItem[] = [];

          const submission: ISubmission = {
            customerId: this.customer.customerId,
            createUserGuid: this.userGuid,
            distributionChannel: this.dataScope,
            riskClass: item['Device Risk Class'],
            skuNumber: item['Product SKU'],
            deviceModel: item['Device Model'],
            applicableLegislation: item['Applicable Regulation'],
            brandName: item['Trade Name'],
            submissionStatusCode: 1,
            registrationTypeCode: registrationTypeCode,
            submissionItems: submissionItems
          };

          if (this.itemType === 'device') {
            const submissionItemDevice: ISubmissionItem = {

              submissionId: '0',
              submissionItemTypeCode: 'device',
              itemId: item['Primary DI'],
              itemIssuingAgency: item['Primary DI Issuing Agency'],
              revision: item['Device Revision'],
              externalSourceId: ''
            };

            submission.submissionItems.push(submissionItemDevice);
          }

          if (this.dataScopeEudamed || this.dataScopeSwissdamed) {
            const submissionItemModel: ISubmissionItem = {

              submissionId: '0',
              submissionItemTypeCode: 'model',
              itemId: this.itemType === 'model' ? item['Basic UDI-DI'] : item['Basic UDI-DI Number'],
              itemIssuingAgency: item['Basic UDI-DI Issuing Agency'],
              revision: item['Model Revision'],
              externalSourceId: ''
            };

            submission.submissionItems.push(submissionItemModel);
          }

          submissions.push(submission);

        });

        if (submissions && submissions.length > 0) {

          let data$: Observable<Object | IServiceError>;

          data$ = this.service.approveSelectedDevices(submissions, this.customer.customerId);
          this.toastr.info('Your request has been submitted', '', { closeButton: true });
          this.subscription = data$.subscribe(data => {

            if (data && data['status'] === MessageSeverityEnum.success) {

              this.toastr.success('Your request has been processed', '', { closeButton: true });
              this.grid.refresh();
            } else {

              this.toastr.error(`Error while sending ${this.capitalize(this.itemType)}(s) for Approval.`, '', { timeOut: 0, closeButton: true });
            }
          });
          this.clearGridSelection();
        }
      }
    }

    this.modalVisible = false;
    this.dialog.hide();
  }

  submissionCancel(event) {

    this.dialog.hide();
    this.modalVisible = false;
  }

  onOverlayClick: EmitType<object> = () => {

    this.modalVisible = false;
    this.dialog.hide();
  }

  btnClick: EmitType<object> = () => {
    this.modalVisible = true;
    this.dialog.show();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    // in this case can't reuse the subscription. Need a separate subscription for the timer
    // to be able to stop the timer on ngOnDestroy. Otherwise it keeps triggering on other pages.
    if (this.revalidationTimerSubscription) {
      this.revalidationTimerSubscription.unsubscribe();
    }

    if (this.validationSelectAllSubscription) {
      this.validationSelectAllSubscription.unsubscribe();
    }

    if (this.tooltipObj && this.tooltipObj.destroy) {
      this.tooltipObj.destroy();
    }

    this.registrationTypeSelection.unsubscribe();
    this.featureServiceSubscription.unsubscribe();

    // clear the selected items storage
    this.storage.write('selectedItems', []);
  }

  getCssClass(data) {

    return { 'small-loading-span': !data['Validation Status'] };
  }
}

class LastCallTime {
  id: string;
  callTime: any;

  constructor(id: string, callTime: any) {
    this.id = id;
    this.callTime = callTime;
  }
}

